import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { sendFormDataWithAttachment } from "../../Services/EmailService";

export type SubmitFormDataWithAttachmentParameter = {
    formData: FormData;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitFormDataWithAttachmentParameter, FormData>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.formData;
};

export const SendDataToApi: HandlerType = async props => {
    await sendFormDataWithAttachment(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitFormDataWithAttachment = createHandlerChainRunner(chain, "SubmitFormDataWithAttachment");
export default submitFormDataWithAttachment;
